import requestKeys from "@/constants/requestKeys";
import { httpClient } from "@/services";
import customerInvoiceListHeader from "@/pages/Accounting/CustomerInvoices/customerInvoiceListHeader";

export default {
	state: {
		customerInvoicesList: null,
		customerInvoicesListCBC: null,
		customerInvoicesFilters: null,
		customerInvoicesFiltersCBC: null,
		customerInvoicesTotals: null,
		customerInvoicesTotalsCBC: null,
		customerInvoicesLimit: null,
		customerInvoicesLimitCBC: null,
		customerInvoicesOrder: null,
		customerInvoicesOrderCBC: null,
		customerInvoicesSort: null,
		customerInvoicesSortCBC: null,
		customerInvoicesTotal: null,
		customerInvoicesTotalCBC: null,
		selectedInvoices: null,
		customerInvoicesPayment: null,
		invoiceFiles: null,
		customerInvoicesData: null,
	},
	mutations: {
		updateCustomerInvoicesList(state, { rows, limit, order, sort, total }) {
			state.customerInvoicesList = rows;
			state.customerInvoicesLimit = limit;
			state.customerInvoicesOrder = order;
			state.customerInvoicesSort = sort;
			state.customerInvoicesTotal = total;
		},
		updateCustomerInvoicesListCBC(state, { rows, limit, order, sort, total }) {
			state.customerInvoicesListCBC = rows;
			state.customerInvoicesLimitCBC = limit;
			state.customerInvoicesOrderCBC = order;
			state.customerInvoicesSortCBC = sort;
			state.customerInvoicesTotalCBC = total;
		},
		updateCustomerInvoicesFiltersCBC(state, { filter }) {
			state.customerInvoicesFiltersCBC = filter;
		},
		updateCustomerInvoicesFilters(state, { filter }) {
			state.customerInvoicesFilters = filter;
		},
		updateSelectedInvoices(state, { invoices }) {
			state.selectedInvoices = invoices;
		},
		updateSelectedInvoicesClear(state, payload) {
			state.selectedInvoices = payload;
			state.customerInvoicesPayment = payload;
		},
		updateCustomerInvoicesPayment(state, payload) {
			state.customerInvoicesPayment = payload;
		},
		updateCustomerInvoicesListEdit(state, { row }) {
			const idx = state.customerInvoicesList.findIndex(item => item.invoice_id === row.invoice_id);
			state.customerInvoicesList.splice(idx, 1, row);
		},
		updateInvoiceFiles(state, payload) {
			state.invoiceFiles = payload;
		},
		updateCustomerInvoicesData(state, payload) {
			state.customerInvoicesData = payload;
		},
		updateCustomerInvoicesTotal(state, { totals }) {
			state.customerInvoicesTotals = totals;
		},
		updateCustomerInvoicesTotalCBC(state, { totals }) {
			state.customerInvoicesTotalsCBC = totals;
		},
		updateSendInvoicesReports(state) {
			state.selectedInvoices = null;
		}
	},
	actions: {
		async sendCustomerBulk({ dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/customer-bulk', values);

				if (data && data.status) {
					dispatch('setAlert', { type: "success", message: "Customers' data has been successfully updated." });
				} else {
					dispatch('setAlert', { type: "error", message: "⚠️ Error.. Oops, something went wrong." });
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async getCustomerInvoicesCBC({ commit, dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/invoice', values);

				if (data && !data.status) {
					commit('updateCustomerInvoicesListCBC', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.INVOICE, defaultHeader: customerInvoiceListHeader });
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getCustomerInvoicesFiltersCBC({ commit }, values) {
			try {
				const { data } = await httpClient.post('/invoice/filters', values);
				if (data) commit('updateCustomerInvoicesFiltersCBC', data);
			} catch (e) {
				console.error(e);
			}
		},

		async getCustomerInvoicesTotalCBC({ commit }, value) {
			try {
				const { data } = await httpClient.post(`/invoice/total`, value);

				if (data && !data.status) {
					commit('updateCustomerInvoicesTotalCBC', data);
					commit('updatePreloaderTotals', false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		
		async getCustomerInvoices({ commit, dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/invoice', values);

				if (data && !data.status) {
					commit('updateCustomerInvoicesList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.INVOICE, defaultHeader: customerInvoiceListHeader });
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getCustomerInvoicesFilters({ commit }, values) {
			try {
				const { data } = await httpClient.post('/invoice/filters', values);
				if (data) commit('updateCustomerInvoicesFilters', data);
			} catch (e) {
				console.error(e);
			}
		},

		async getCustomerInvoicesTotal({ commit }, value) {
			try {
				const { data } = await httpClient.post(`/invoice/total`, value);

				if (data && !data.status) {
					commit('updateCustomerInvoicesTotal', data);
					commit('updatePreloaderTotals', false);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getSelectedInvoices({ commit, dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/invoice/invoiceEmail', values);

				if (data && data.status) {
					commit('updateSelectedInvoices', data);
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onSendInvoicesReports( { commit }, values) {
			try {
				const { data } = await httpClient.post('invoice/sendInvoices', values);
				// обнуляем selectedInvoices в state
				commit('updateSendInvoicesReports', null);
				if (data) return data;
			} catch (e) {
				console.error(e);
			}
		},

		onSelectedInvoicesClear({ commit }) {
			try {
				commit('updateSelectedInvoicesClear', null);
			} catch (e) {
				console.error(e);
			}
		},

		async getCustomerInvoicesPayment({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/payments/new/${ id }`);
				if (data) {
					commit('updateCustomerInvoicesPayment', data);
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getGenerateInvoice() {
			try {
				const { data } = await httpClient.get(`/generate-invoice/create`);
				if (data) return data;
			} catch (e) {
				console.error(e);
			}
		},

		async onGenerateInvoice({ dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post(`/generate-invoice`, values);

				if (data) {
					dispatch('setAlert', { type: "success", message: "🧾✨ The invoice generation process has started. Waiting time is approximately 20 minutes." });
					return data;
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onCustomerInvoicesPayment({ commit, dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post(`/payments/${ values.invoice_id }`, values);

				if (data && data.status) {
					commit('updateCustomerInvoicesListEdit', data);
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getInvoiceFiles({ commit, dispatch }, id) {
			if (!id) return commit('updateInvoiceFiles', null);
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post(`/invoice/file/${ id }`);

				if (data) {
					commit('updateInvoiceFiles', data.rows);
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getInvoiceOpen({ dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post(`/invoice/open/${ id }`);
				if (data) {
					dispatch('setAlert', { type: "success", message: "✔️ Success: The invoice has been opened successfully. 😉" });
					return true;
				}
			} catch (e) {
				dispatch('setAlert', { type: "error", message: "⚠️ Error: Failed to open the invoice. Please check the file and try again." });
				console.error(e);
				return false;
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onSendInvoice(context, values) {
			try {
				const { data } = await httpClient.post('invoice/sendInvoice', values);
				if (data) return data;
			} catch (e) {
				console.error(e);
			}
		},

		async onDeleteInvoice({ dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post(`/invoice/delete/${ id }`, { invoice_id: id });
				if (data) {
					dispatch('setAlert', { type: "success", message: "✔️ The invoice has been successfully deleted." });
					return true;
				}
			} catch (e) {
				dispatch('setAlert', { type: "error", message: "⚠️ Error: The invoice could not be deleted." });
				console.error(e);
				return false;
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		onCustomerInvoicesClear({ commit }) {
			try {
				commit('updateCustomerInvoicesFilters', { filter: null });
			} catch (e) {
				console.error(e);
			}
		},

		/* eslint-disable-next-line */
		async onCustomerInvoicesData({ commit, dispatch }, { id, values }) {
			dispatch("actionPreloader", true);
			const uri = id ? `invoice/${ id }` : 'invoice/new';
			try {
				const { data } = await httpClient.post(uri, values);
				if (data) {
					commit('updateCustomerInvoicesData', data);
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onCustomerInvoicesSave({ dispatch }, { id, ...obj }) {
			dispatch("actionPreloader", true);
			const uri = id ? `invoice/update/${ id }` : 'invoice/update';
			try {
				const { data } = await httpClient.post(uri, obj);
				if (data) return data;
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onAddPayments({ dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('invoice/setPayments', values);
				if (data) return data;
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		}
	},
	getters: {
		customerInvoicesList: (s) => s.customerInvoicesList,
		customerInvoicesFilters: (s) => s.customerInvoicesFilters,
		customerInvoicesTotals: (s) => s.customerInvoicesTotals,
		customerInvoicesLimit: (s) => s.customerInvoicesLimit,
		customerInvoicesOrder: (s) => s.customerInvoicesOrder,
		customerInvoicesSort: (s) => s.customerInvoicesSort,
		customerInvoicesTotal: (s) => s.customerInvoicesTotal,
		selectedInvoices: (s) => s.selectedInvoices,
		customerInvoicesPayment: (s) => s.customerInvoicesPayment,
		invoiceFiles: (s) => s.invoiceFiles,
		customerInvoicesData: (s) => s.customerInvoicesData,

		customerInvoicesListCBC: (s) => s.customerInvoicesListCBC,
		customerInvoicesLimitCBC: (s) => s.customerInvoicesLimitCBC,
		customerInvoicesOrderCBC: (s) => s.customerInvoicesOrderCBC,
		customerInvoicesSortCBC: (s) => s.customerInvoicesSortCBC,
		customerInvoicesTotalCBC: (s) => s.customerInvoicesTotalCBC,
		customerInvoicesFiltersCBC: (s) => s.customerInvoicesFiltersCBC,
		customerInvoicesTotalsCBC: (s) => s.customerInvoicesTotalsCBC,

	}
};
